import { SlideoutMenu } from "@/components/application/slideout-menus/slideout-menu";

interface RulesListLoadingDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  overlayClassName?: string;
}

export function RulesListLoadingDrawer({ open, onOpenChange, overlayClassName }: RulesListLoadingDrawerProps) {
  return (
    <SlideoutMenu isOpen={open} onOpenChange={onOpenChange} isDismissable className={overlayClassName}>
      <SlideoutMenu.Header onClose={() => onOpenChange(false)}>
        <h2 className="text-lg font-semibold text-primary">Sample Auto-Approval Rules</h2>
      </SlideoutMenu.Header>

      <SlideoutMenu.Content>
        <div className="flex flex-col divide-y divide-secondary">
          {[0, 1, 2].map((i) => (
            <div key={i} className="flex flex-row items-center justify-between gap-3 py-3">
              <div className="flex flex-col gap-1.5">
                <span className="block h-4 w-32 animate-pulse rounded bg-secondary" aria-hidden />
                <span className="block h-3 w-24 animate-pulse rounded bg-secondary" aria-hidden />
              </div>
              <span className="block h-6 w-16 animate-pulse rounded-full bg-secondary" aria-hidden />
            </div>
          ))}
        </div>
      </SlideoutMenu.Content>
    </SlideoutMenu>
  );
}
